/*
  product.js — le script de la fiche produit (DRAYKI v3). Un module ES, chargé par
  les sections de la fiche : <script type="module" src="{{ 'product.js' | asset_url }}">
  (un module ne s'exécute qu'une fois, même demandé par plusieurs sections). drayki.js
  (defer, dans la tête) est déjà là : window.DRAYKI existe, le système démarre au
  DOMContentLoaded, après ce module ; les sections ci-dessous sont lancées à ce
  moment-là, puis de nouveau à chaque shopify:section:load (la section en racine).

  Source : le <script> de machina.html (maquette r7), porté ligne pour ligne autant
  que possible ; chaque retouche pour le thème est marquée « THEME: ».
    machina.html  modifié le 27/09/2026 02:15:50 (+02:00)
    sha256 du fichier     aacd0be6c85d4ba96389d1123461ccd36c78e9249652a9d442426c4e8a401d91
    sha256 du <script>    ded552bfea758eb23f7acbfaf636094fe48820772a7c3fe08285262089eb4920
  Base de la fusion à trois (docs/02 §9.3) : scratchpad/product-pkg/sync/
  (machina.html.base, machina.script.js).

  Sections (DRAYKI.section) :
    'variants'  THEME: le choix de version (la maquette n'en avait pas), et ses
                copies (01/10 : le dock, la ligne du haut, la coda)
    'mix'       le mix : 2 kits au plus, la tuile qui tombe sur la pile, la somme,
                « get all 3 » (le vrai panier : DRAYKI.cart.addMany)
    'handover'  la pilule devient le dock (téléphone, avec mouvement)
    'moments'   les arrivées lues sur le scroll (r7)
    'bundle'    THEME: les kits de la version choisie du bundle (bundle-contents)
    'reviews'   THEME: les dates des avis de Judge.me dites « 12 aug 2026 » (un
                observateur par .rv)
    'about'     THEME (r8): « read more » de la description (snippet about-card :
                la coupe posée par le CSS, déplier / replier, la coupe retirée
                quand le texte tient en entier à cette largeur)
  Écouteurs délégués, posés une fois : le lien d'évitement « skip to get … », la
  liste des fichiers (la rangée atteinte au clavier ramenée dans la vue), « write a
  review » (le lien caché du widget Judge.me), le nettoyage à shopify:section:unload.
  Toutes les données viennent de la page (Liquid) : <script data-product-json>,
  <script data-mix-json>, <script data-bundle-map>, les attributs data- ; aucun nom,
  aucun prix, aucun kit écrit ici.
*/
(() => {
  'use strict';
  const W = window, doc = document;
  const D = W.DRAYKI;
  if (!D || !D.section) return;
  const $ = (s, r = doc) => r.querySelector(s);
  const $$ = (s, r = doc) => Array.from(r.querySelectorAll(s));
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
  // THEME: the page's own data, the root a section's init is given, the money
  const within = (scope) => (scope && scope !== doc && scope.querySelectorAll ? scope : doc);
  const json = (el) => { if (!el) return null; try { return JSON.parse(el.textContent || 'null'); } catch (e) { return null; } };
  const money = (c) => (typeof D.fmt === 'function' ? D.fmt(c) : (c / 100).toFixed(2));
  const VARS = new Map();   // handle → the version chosen now ({ id, title, price, compare, avail, money, compare_money })

  // THEME: the kits to pick are written by Liquid (section product-mix: the
  // object with data-enter, the author line, the name, the price, the key);
  // the mockup wrote them here from DRAYKI.BY before the system mounted the page.

  /* ---------------------------------------------------- THEME: the versions */
  // (the mockup had none: docs/02 §2.4) The picker's radios (snippet
  // variant-picker) carry name="id" for the page without script; here the
  // hidden #hidden-variant-id takes the name back and the radios lose it. A
  // choice writes the hidden id, the prices [data-price="h"] (and their
  // discount, [data-price-off]), the keys [data-add="h"] (data-variant; a
  // version not for sale: disabled, « sold out »), a direct link
  // [data-permalink] (/cart/<id>:1),
  // the Kaching form's id (input[data-vid]), the address (?variant=,
  // replaceState), then drayki:variant for the rest (the mix, the bundle's
  // kits, the system). Wired as soon as the module runs (a choice made
  // before the system starts still counts), and again on the editor's load.
  // THEME (01/10/2026, drayki: "les differentes variations des drumkits sont
  // difficilement visibles une fois passé le hero, j'aimerai qu'on les voit
  // ailleurs notamment dans la partie sticky en bas") The picker has copies
  // (.vp[data-vp-at]: the dock's, the top line's, the coda's — snippet
  // variant-picker, at): a choice writes every one of them, and a choice
  // made in one is the first screen's choice (one listener for the page,
  // below: they live in other sections, the header among them). Copies of a
  // picker the first screen does not show are taken out.
  const PICK = new Map();   // handle → choose(id), for the copies
  function variants(scope) {
    for (const js of $$('script[data-product-json]', within(scope))) {
      if (js._v) continue;
      const P = json(js);
      if (!P || !P.h || !Array.isArray(P.variants) || !P.variants.length) continue;
      js._v = true;
      const h = P.h, S = P.strings || {};
      const byId = new Map(P.variants.map((v) => [String(v.id), v]));
      const hid = $('#hidden-variant-id');
      const box = $(`.vp[data-vp="${h}"]:not([data-vp-at])`);   // THEME: the first screen's own
      const radios = box ? $$('input[type="radio"]', box) : [];
      if (radios.length) {
        if (hid) hid.name = 'id';
        for (const r of radios) { r.name = `vp-${h}`; r.removeAttribute('form'); }
      }
      let cur = byId.get(String(P.selected)) || P.variants[0];
      VARS.set(h, cur);
      // (a version not for sale: its keys disabled, « sold out » — the system
      // leaves a disabled key's words alone; for sale again, their words back)
      const sale = (b, ok) => {
        const lb = $('.lb', b), was = !!b.disabled;
        if (b.tagName === 'BUTTON') b.disabled = !ok;
        if (!ok) { b.classList.remove('on'); if (lb && S.sold_out) lb.textContent = S.sold_out; return; }
        if (was) {
          const lab = b.getAttribute('data-label');
          if (lb && lab) lb.textContent = lab.replace('{name}', P.name || '');
          b._on = null;   // (the system's own mark: it writes the key's words again)
        }
      };
      const select = (v) => {
        cur = v; VARS.set(h, v);
        if (hid) hid.value = v.id;
        for (const r of radios) r.checked = r.value === String(v.id);
        for (const r of $$(`.vp[data-vp="${h}"][data-vp-at] input[type="radio"]`)) r.checked = r.value === String(v.id);   // THEME: the copies
        for (const el of $$(`[data-price="${h}"]`)) {
          el.innerHTML = `<b>${v.money}</b>` + (v.compare_money ? `<s><span class="vh">${esc(S.was || '')} </span>${v.compare_money}</s>` : '');
        }
        for (const el of $$(`[data-price-off="${h}"]`)) {
          const pc = v.compare ? Math.round(((v.compare - v.price) / v.compare) * 100) : 0;
          el.hidden = !pc;
          if (pc) el.textContent = (S.off || '−{percent} %').replace('{percent}', pc);
        }
        for (const b of $$(`[data-add="${h}"]`)) { b.setAttribute('data-variant', v.id); sale(b, v.avail); }
        // THEME (01/10/2026): the wallet under the pill (main-product, « Paiement
        // express ») buys what the form's id says, read by Shopify's button when it
        // is pressed; a change event tells it the id moved too. Not for sale: the
        // wallet is hidden in its place and takes no focus (data-xp-off, inert).
        if (hid) hid.dispatchEvent(new Event('change', { bubbles: true }));
        for (const x of $$('.pdp-xp')) { x.toggleAttribute('data-xp-off', !v.avail); x.inert = !v.avail; }
        for (const a of $$(`a[data-permalink="${h}"]`)) a.href = (P.permalink || '/cart/{id}:1').replace('{id}', v.id);
        for (const i of $$(`input[data-vid="${h}"]`)) i.value = v.id;
        try {
          const u = new URL(W.location.href);
          u.searchParams.set('variant', v.id);
          W.history.replaceState(W.history.state, '', `${u.pathname}${u.search}${u.hash}`);
        } catch (e) { /* fine */ }
        doc.dispatchEvent(new CustomEvent('drayki:variant', { detail: { h, variant: { id: v.id, title: v.title, price: v.price, compare: v.compare, avail: v.avail } } }));
        if (D.ready && typeof D.syncAdd === 'function') D.syncAdd();
      };
      for (const r of radios) {
        r.addEventListener('change', () => { if (!r.checked) return; const v = byId.get(r.value); if (v && v !== cur) select(v); });
      }
      // THEME: a copy's choice (the listener below)
      if (radios.length) PICK.set(h, (id) => { const v = byId.get(String(id)); if (v && v !== cur) select(v); });
      // (a page brought back by the browser can come back with another radio checked)
      const on = radios.find((r) => r.checked);
      if (on && on.value !== String(cur.id) && byId.get(on.value)) select(byId.get(on.value));
      else if (hid && hid.value !== String(cur.id)) hid.value = cur.id;
    }
    // THEME: the copies in this scope (the page; a section the editor draws
    // again comes with the first version checked) say the version chosen now;
    // a copy with no picker on the first screen goes
    for (const c of $$('.vp[data-vp-at]', within(scope))) {
      const h = c.dataset.vp;
      if (!$(`.vp[data-vp="${h}"]:not([data-vp-at])`)) { c.remove(); continue; }
      const v = VARS.get(h);
      if (v) for (const r of $$('input[type="radio"]', c)) r.checked = r.value === String(v.id);
    }
  }
  variants(doc);
  D.section('variants', variants);
  doc.addEventListener('change', (e) => {
    const r = e.target, c = r && r.type === 'radio' && r.checked && r.closest ? r.closest('.vp[data-vp-at]') : null;
    const f = c && PICK.get(c.dataset.vp);
    if (f) f(r.value);
  });

  // THEME: a stack drawn again with other kits (the mix's rebuild, below, made
  // a helper for the bundle's kits too): the old one leaves the loop, the new
  // one is mounted whole at once (it is already on the screen), then only
  // the kit just added comes down (the system's drop, from inside the
  // stack's own box). What else kit-stack wrote on it is kept; its words for
  // a screen reader, if it has them, are written again.
  const restack = (wrap, hs, pose, added, label) => {
    const old = $('.stack', wrap);
    if (old && old._stack) D.unregister(old._stack);
    const el = doc.createElement('div');
    el.className = 'stack'; el.dataset.stack = hs.join(' '); el.dataset.tw = '52';
    if (pose) el.dataset.pose = pose;
    if (old) {
      for (const a of Array.from(old.attributes)) if (!/^(class|style|data-stack|data-tw|data-pose)$/.test(a.name)) el.setAttribute(a.name, a.value);
      if (el.hasAttribute('aria-label') && label) el.setAttribute('aria-label', label);
      old.replaceWith(el);
    } else wrap.appendChild(el);
    D.mount(wrap);
    const s = el._stack; if (!s) return;
    // (already on the screen: whole at once, then only the new tile comes down)
    s.q = 1; s.done = true; s.layout(); s.write(true);
    // (the system's drop: from inside the stack's own box, never over the title)
    if (added && s.dropIn) s.dropIn(added);
  };

  /* --------------------------------------------------------- the mix */
  // this kit at the bottom of the stack, then the kits picked (up to 2; a
  // third takes the place of the first). The stack is rebuilt for each
  // change (the old one leaves the loop); the tile just picked is set down
  // from above, on its own clock (nothing at rest after it). The figure,
  // the sum and the pill follow; the pill puts them all in the cart.
  D.section('mix', (scope) => {
    for (const sec of $$('.mix[data-mix]', within(scope))) {   // THEME: the section by its data (the page's product)
      if (sec._mix) continue;
      const M = json($('script[data-mix-json]', sec));
      if (!M || !M.h) continue;
      sec._mix = true;
      const S = M.strings || {};
      const wrap = $('.mix-st', sec), fig = $('[data-mix-fig]', sec), figP = fig.parentElement;
      const sumEl = $('[data-mix-sum]', sec), add = $('[data-mix-add]', sec), addL = $('.lb', add);
      const pose = ($('.stack', wrap) || {}).dataset?.pose || '';
      const items = $$('.pick', sec);
      // THEME: the kits to pick as the page wrote them (their default version,
      // its price in cents, the name), the kits picked at first (li.pick.on),
      // this kit's chosen version, the tiers from the theme's settings
      const K = new Map(items.map((li) => [li.dataset.pick, { vid: +li.dataset.vid, cents: +li.dataset.cents || 0, name: (($('.nm', li) || {}).textContent || li.dataset.pick).trim() }]));
      let picks = items.filter((li) => li.classList.contains('on')).map((li) => li.dataset.pick);
      const v0 = VARS.get(M.h);
      let cur = v0 ? { vid: v0.id, cents: v0.price } : { vid: M.vid, cents: M.cents };
      const TIERS = (M.tiers || []).map((t) => ({ n: +t[0], off: +t[1] }));   // (the discounts in %: settings.tier2_off, tier3_off)
      const has = (r) => !!(r && D.cart && typeof D.cart.has === 'function' && D.cart.has(r));
      const sync = () => {
        const hs = [M.h, ...picks], n = hs.length;
        const tier = TIERS.slice().reverse().find((t) => n >= t.n), off = tier ? tier.off : 0;
        const s = cur.cents + picks.reduce((a, h) => a + ((K.get(h) || {}).cents || 0), 0);
        fig.textContent = `−${off || (TIERS[0] ? TIERS[0].off : 0)}`;
        figP.classList.toggle('dim', !off);
        sumEl.innerHTML = n === 1
          ? esc(S.alone || '')
          : `${[M.name, ...picks.map((h) => (K.get(h) || {}).name || h)].map((x) => esc(x)).join(' + ')} — <span class="price"><b>${money(Math.round(s * (1 - off / 100)))}</b><s><span class="vh">${esc(S.instead || '')} </span>${money(s)}</s></span>`;
        const inCart = has(cur.vid) && picks.every((h) => has((K.get(h) || {}).vid) || has(h));
        addL.textContent = inCart ? (n === 1 ? S.one_in : S.all_in) : n === 1 ? S.one : n === 2 ? S.both : S.all;
        for (const li of items) {
          const on = picks.includes(li.dataset.pick), b = $('.btn', li);
          li.classList.toggle('on', on);
          b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
          const lb = $('.lb', b); if (lb) lb.textContent = on ? S.in : S.mix;   // THEME: the word's own span (the name before it is for a screen reader)
        }
        // THEME: the form without script says the same kits (if the click is
        // ever not taken here, the page still adds what it shows)
        if (add.form) {
          for (const i of $$('input[name="items[][id]"], input[name="items[][quantity]"]', add.form)) i.remove();
          add.form.insertAdjacentHTML('afterbegin', [cur.vid, ...picks.map((h) => (K.get(h) || {}).vid)].filter(Boolean)
            .map((id) => `<input type="hidden" name="items[][id]" value="${esc(id)}"><input type="hidden" name="items[][quantity]" value="1">`).join(''));
        }
      };
      const label = () => (S.stacked ? S.stacked.replace('{count}', picks.length + 1).replace('{names}', [M.name, ...picks.map((h) => (K.get(h) || {}).name || h)].join(', ')) : '');
      const rebuild = (added) => restack(wrap, [M.h, ...picks], pose, added, label());
      for (const li of items) {
        li.addEventListener('click', () => {
          const h = li.dataset.pick;
          if (picks.includes(h)) { picks = picks.filter((x) => x !== h); rebuild(null); }
          else { picks.push(h); if (picks.length > 2) picks.shift(); rebuild(h); }
          sync();
        });
      }
      add.addEventListener('click', (e) => {
        // THEME: the real cart, one request for all of them (a kit already in
        // it opens the cart instead), then the cart opens
        e.preventDefault();
        if (add.getAttribute('aria-busy') === 'true') return;
        const refs = [cur.vid, ...picks.map((h) => (K.get(h) || {}).vid || h)];
        if (!D.cart || typeof D.cart.addMany !== 'function') { if (add.form) add.form.submit(); return; }
        add.setAttribute('aria-busy', 'true');
        Promise.resolve(D.cart.addMany(refs, { open: true }))
          .catch((err) => { console.error(err); })
          .finally(() => { add.removeAttribute('aria-busy'); });
      });
      const onCart = () => sync();
      // THEME: another version of this kit chosen: its price in the sum
      const onVar = (e) => { const d = e.detail; if (d && d.h === M.h && d.variant) { cur = { vid: d.variant.id, cents: d.variant.price }; sync(); } };
      doc.addEventListener('drayki:cart', onCart);
      doc.addEventListener('drayki:variant', onVar);
      sec._off = () => { doc.removeEventListener('drayki:cart', onCart); doc.removeEventListener('drayki:variant', onVar); };
      sync();
    }
  });

  /* ------------------------------------------------- the buy action */
  // One buy action on the screen at a time: the first screen's pill, or,
  // once it has handed over, the dock's key (a phone) or the top line's
  // (wide). While the pill is on the screen the dock trades places with it
  // (or with its twin, below) in one frame (.at-pill, the page's CSS). The
  // skip link goes to the one on the screen (its #MainActionBlock is the
  // way without the script, where the pill never goes); a focus on the
  // pill as it hands over goes with it to the dock's key, and back.
  // THEME: read again at each call (the theme's editor draws a section again)
  const keys = () => {
    const pill = $('#AddToCart-Main'), dock = $('#sticky-atc-bar');
    return { pill, dock, dkKey: dock && $('.go', dock), topKey: $('.top .top-add'), pdp: $('.pdp'), row: $('.pdp .buy-r'), sent: $('#buy-gone') };
  };
  const root = doc.documentElement;
  const shown = (el) => !!el && getComputedStyle(el).display !== 'none';
  const docked = (k) => !!k.dock && k.dock.classList.contains('on') && !k.dock.classList.contains('held') && !k.dock.classList.contains('morph') && shown(k.dock);
  const live = (k) => (docked(k) ? k.dkKey : k.topKey && shown(k.topKey) ? k.topKey : k.pill);
  const follow = (k) => {
    const a = doc.activeElement;
    if (a === k.pill && docked(k)) k.dkKey.focus({ preventScroll: true });
    else if (a === k.dkKey && !docked(k) && k.pdp && !k.pdp.classList.contains('handed')) k.pill.focus({ preventScroll: true });
  };

  /* ------------------------------- THEME: the pill's words and its arrow */
  // A row whose price is struck leaves the pill less room on a phone (the
  // page's CSS tightens it; its words give way before its arrow ever leaves
  // it). Where the words would still reach the arrow — a longer name, « get
  // bundles » beside « €149,99 €399,99 » — they take its room (.tight, as in
  // the cart; the twin of the hand-over does the same). Measured with the
  // arrow there: once the font is in, then on a resize, a version chosen, the
  // cart changed (the words and the price change). Nothing at rest.
  const tight = () => {
    for (const p of $$('.buy-r .go')) {
      const lb = $('.lb', p), ar = $('.arr', p);
      if (!lb || !ar) continue;
      p.classList.remove('tight');
      const a = ar.getBoundingClientRect();
      if (!a.width) continue;   // (no arrow drawn: in the cart, or a narrow phone's struck row)
      // (closer than 10px — the tight row's own gap is 12 — is too close)
      if (lb.getBoundingClientRect().left + lb.scrollWidth > a.left - 10) p.classList.add('tight');
    }
  };
  let tq = 0;
  const tightSoon = () => { if (!tq) tq = W.requestAnimationFrame(() => { tq = 0; tight(); }); };
  tight();
  if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(tightSoon);
  W.addEventListener('resize', tightSoon, { passive: true });
  doc.addEventListener('drayki:variant', tightSoon);
  doc.addEventListener('drayki:cart', tightSoon);
  D.section('tight', tightSoon);   // (and again when the editor draws the first screen or the coda again)

  /* ---------------- THEME: the first screen, less the launch bar (01/10/2026) */
  // The first screen holds the wallet under the pill now (main-product,
  // « Paiement express »). The launch bar over the top line (snippets/sale-bar,
  // shown until 05/10 19:00) pushed the whole first screen down by its height,
  // and on a phone the wallet went under the fold. Where the first screen is
  // one column, it is the screen less the bar: its height, --sale-h on <html>
  // (product.css). The bar's own inline script sets it as it shows, before
  // the first screen is read (01/10/2026: set here first, after the first
  // paint, the whole first screen moved up 37px while the page loaded). Here
  // it is only read again when the bar's height changes (a turn, the font
  // come in and its words on one line more or less).
  const sbar = () => {
    const b = doc.getElementById('sale-bar');
    if (!b || b.hidden) return;
    const h = `${b.offsetHeight}px`;
    if (root.style.getPropertyValue('--sale-h') !== h) root.style.setProperty('--sale-h', h);
  };
  {
    const b = doc.getElementById('sale-bar');
    if (b && !b.hidden && 'ResizeObserver' in W) new ResizeObserver(sbar).observe(b);
    else if (b && !b.hidden) W.addEventListener('resize', sbar, { passive: true });
  }

  /* ---------------------------------------- the pill becomes the dock */
  // (r6, drayki: "animation du bouton get machina to le sticky pill
  // « machina 24,99 add »") Where the dock is drawn (a phone, an upright
  // tablet, a phone on its side), with motion: over the first R px of the
  // scroll (9 % of the screen, 56–96px), read off the system's follower,
  // never faster than MIN for the whole, a twin of the dock (.hand, fixed,
  // over the object) takes the pill's place and becomes the dock: the
  // violet body shrinks into the dock's "add" key (its words trade on the
  // way), the dock's bar grows out from under it, the price travels and
  // shrinks into the dock's price, the name comes in. At its end it is the
  // dock, pixel for pixel, and the two trade in one frame. The pill's
  // sentinel (#buy-gone) is moved to R, so the system's dock comes up just
  // there; until the twin has arrived it waits (.morph). Stopped half-way,
  // it goes to the nearer end on its own clock. Its boxes are measured
  // from the screen's foot (the dock's own anchor: a phone's bars folding
  // away move them both). Transform and opacity only; nothing at rest.
  // Without motion, or wide: nothing of this (the sentinel stays at the
  // row's foot, the system's swap).
  D.section('handover', () => {
    const k = keys();
    const { pill, dock, dkKey, row, pdp, sent } = k;
    if (!dock || !pill || !pdp) return;
    // THEME: the dock beside the pill (.at-pill), once per first screen
    if (!pdp._atPill && 'IntersectionObserver' in W) {
      pdp._atPill = new IntersectionObserver((es) => { for (const e of es) dock.classList.toggle('at-pill', e.isIntersecting); });
      pdp._atPill.observe(pill.closest('.buy') || pill);
    }
    if (!row || !sent || !dkKey || pdp._hand) return;
    const E = D.engine, MIN = .42;
    const seg = (v, a, b) => Math.min(1, Math.max(0, (v - a) / (b - a)));
    const lerp = (a, b, t) => a + (b - a) * t;
    const ease = (t) => (t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
    const f2 = (v) => v.toFixed(2);
    const G = doc.createElement('div');
    G.className = 'hand'; G.setAttribute('aria-hidden', 'true');
    G.innerHTML =
      '<i class="h-be"></i><i class="h-be"></i><i class="h-bm"></i>' +
      '<i class="h-pe"></i><i class="h-pe"></i><i class="h-pm"></i>' +
      `<span class="go h-lb">${$('.lb', pill).outerHTML}</span><span class="go h-ar">${($('.arr', pill) || { outerHTML: '' }).outerHTML}</span>` +
      `<span class="go sm h-add">${dkKey.innerHTML}</span>` +
      '<span class="h-nm"></span><span class="h-pc"></span><span class="h-pd"></span>';
    doc.body.appendChild(G);
    const [bl, br, bm, pl, pr, pm, gLb, gAr, gAdd, gNm, gPc, gPd] = Array.from(G.children);
    // (its violet body is the key, as on the dock: a tap there adds and
    // opens the cart; the bar takes a tap as the dock's does, for nothing)
    G.addEventListener('click', (e) => { if (e.target.classList.contains('h-pe') || e.target.classList.contains('h-pm')) pill.click(); });
    const prom = $('.pdp-pr', pdp);
    const xp = $('.pdp-xp', pdp);   // THEME (01/10/2026): the wallet under the pill (see write)
    // THEME (01/10/2026, drayki: "sur mobile on ne peut pas cliquer les
    // variations ca bug") The versions of the first screen stay while the
    // pill becomes the dock, over the object (product.css: a tap there is
    // theirs), and give way once the dock is up — R px into the scroll,
    // before the object comes down over their place — to the dock's own row
    // of them (see "the versions" above); back as the page comes back up.
    const vpk = $('.vp:not([data-vp-at])', pdp);
    const H = pdp._hand = { always: true, on: false, p: 0, snap: null, snapY: 0, key: '' };
    let P, Q, B, K, N, C0, C1, R = 80, fs0 = 22, fs1 = 13;

    // (toggle with its force only: it writes the attribute only on a
    // change — add / remove always write it, and the dock's observer
    // below would call this again, for ever)
    const vis = () => {
      const held = dock.classList.contains('held'), dockOn = dock.classList.contains('on') && !held;
      const ghost = H.on && !held && H.p > 0 && (H.p < 1 || (!dockOn && E.S < R + E.vh * .5));
      G.classList.toggle('on', ghost);
      root.classList.toggle('hand-up', ghost);
      dock.classList.toggle('morph', H.on && H.p < 1);
      pdp.classList.toggle('handed', H.on ? (H.p > 0 && !held) || dockOn : dockOn && !!H.drawn);
      // (the player's bar keeps off the pill while it is at the screen's
      // foot, and comes back over the twin once it has nearly arrived)
      root.classList.toggle('pill-foot', !!H.drawn && dock.classList.contains('at-pill') && (H.on ? H.p < .7 : !dockOn));
      // THEME (01/10/2026): the first screen's versions, gone while the dock is
      // up (from R on; held under the add bar, still up) — see vpk
      if (vpk) pdp.classList.toggle('vp-gone', H.on && dock.classList.contains('on'));
      follow(k);
    };
    const write = () => {
      const ih = W.innerHeight, sy = Math.min(W.scrollY, R);
      const key = `${H.p.toFixed(4)}|${sy}|${ih}`;
      if (key === H.key) return;
      H.key = key;
      const e = ease(H.p);
      // the pill's body: from where the page's pill is now to the key
      const py = P.y - sy - ih;
      const x = lerp(P.x, K.x, e), y = lerp(py, K.y, e), w = lerp(P.w, K.w, e), h = lerp(P.h, K.h, e), s = h / K.h;
      pl.style.transform = `translate(${f2(x)}px,${f2(y)}px) scale(${s.toFixed(4)})`;
      pr.style.transform = `translate(${f2(x + w - h)}px,${f2(y)}px) scale(${s.toFixed(4)})`;
      pm.style.transform = `translate(${f2(x + h / 2)}px,${f2(y)}px) scale(${((w - h) / 100).toFixed(4)},${s.toFixed(4)})`;
      // the bar: comes in around the whole row (the price and the pill)
      // and closes to the dock's
      const qy = Q.y - sy - ih;
      const bx = lerp(Q.x, B.x, e), by = lerp(qy, B.y, e), bw = lerp(Q.w, B.w, e), bh = lerp(Q.h, B.h, e), bs = bh / B.h;
      const bo = seg(e, 0, .25).toFixed(3);
      bl.style.transform = `translate(${f2(bx)}px,${f2(by)}px) scale(${bs.toFixed(4)})`;
      br.style.transform = `translate(${f2(bx + bw - bh)}px,${f2(by)}px) scale(${bs.toFixed(4)})`;
      bm.style.transform = `translate(${f2(bx + bh / 2)}px,${f2(by)}px) scale(${((bw - bh) / 100).toFixed(4)},${bs.toFixed(4)})`;
      bl.style.opacity = br.style.opacity = bm.style.opacity = bo;
      // the words: the pill's go with its left end, its arrow with its
      // right end; the key's come in at the right end
      gLb.style.transform = `translate(${f2(x)}px,${f2(y + (h - P.h) / 2)}px)`;
      gLb.style.opacity = (1 - seg(e, 0, .28)).toFixed(3);
      gAr.style.transform = `translate(${f2(x + w - P.w)}px,${f2(y + (h - P.h) / 2)}px)`;
      gAr.style.opacity = (1 - seg(e, .12, .42)).toFixed(3);
      gAdd.style.transform = `translate(${f2(x + w - K.w)}px,${f2(y + (h - K.h) / 2)}px)`;
      gAdd.style.opacity = seg(e, .36, .76).toFixed(3);
      // the name, at the bar's left; the price, carried and made small
      gNm.style.transform = `translate(${f2(bx + N.dx)}px,${f2(by + N.dy * bs)}px)`;
      gNm.style.opacity = seg(e, .5, .95).toFixed(3);
      const cx = lerp(C0.x, C1.x, e), cy = lerp(C0.y - sy - ih, C1.y, e), sc = lerp(1, fs1 / fs0, e);
      gPc.style.transform = `translate(${f2(cx)}px,${f2(cy)}px) scale(${sc.toFixed(4)})`;
      gPd.style.transform = `translate(${f2(cx)}px,${f2(cy)}px) scale(${(sc * fs0 / fs1).toFixed(4)})`;
      gPc.style.opacity = (1 - seg(e, .7, .96)).toFixed(3);
      gPd.style.opacity = seg(e, .7, .96).toFixed(3);
      // the two promises leave with the pill (their line is in its path)
      if (prom) prom.style.opacity = e > 0 ? (1 - seg(e, 0, .28)).toFixed(3) : '';
      // THEME (01/10/2026): the wallet under the pill too (the pill's body
      // passes over it on its way down); gone, it takes no focus either
      if (xp) {
        const xo = 1 - seg(e, 0, .28);
        xp.style.opacity = e > 0 ? xo.toFixed(3) : '';
        xp.style.visibility = xo <= 0 ? 'hidden' : '';
      }
    };
    H.layout = () => {
      const was = H.on;
      H.drawn = shown(dock);
      H.on = !!E.on && H.drawn;
      if (!H.on) { sent.style.top = ''; H.p = 0; if (prom) prom.style.opacity = ''; if (xp) { xp.style.opacity = ''; xp.style.visibility = ''; } vis(); return; }
      const cs = (el) => getComputedStyle(el);
      const sy = W.scrollY, ih = W.innerHeight;
      const r = pill.getBoundingClientRect();
      P = { x: r.left, y: r.top + sy, w: r.width, h: r.height };
      const from = $('.from', row), hp = $('.price', from) || from, c = hp.getBoundingClientRect();
      C0 = { x: c.left, y: c.top + sy };
      fs0 = parseFloat(cs(hp).fontSize) || 22;
      // the dock at rest (its slide taken off for the measure, put back
      // without a transition)
      const t0 = dock.style.transition;
      dock.style.transition = 'none'; dock.style.transform = 'none';
      const b = dock.getBoundingClientRect(), kk = dkKey.getBoundingClientRect();
      const nm = $('.nm', dock), n = nm.getBoundingClientRect();
      const dp = $('.price', dock) || nm, d = dp.getBoundingClientRect();
      dock.style.transform = ''; void dock.offsetWidth; dock.style.transition = t0;
      B = { x: b.left, y: b.top - ih, w: b.width, h: b.height };
      K = { x: kk.left, y: kk.top - ih, w: kk.width, h: kk.height };
      N = { dx: n.left - b.left, dy: n.top - b.top };
      C1 = { x: d.left, y: d.top - ih };
      fs1 = parseFloat(cs(dp).fontSize) || 13;
      // where the bar starts: around the whole row, the price and the pill
      // held in it as the dock holds its own, at the pill's height
      const qx = Math.max(4, C0.x - (C1.x - B.x)), qr = Math.min(root.clientWidth - 4, P.x + P.w + (B.x + B.w - K.x - K.w));
      Q = { x: qx, y: P.y, w: qr - qx, h: P.h };
      // the twin's words, as the pill's and the dock's own (read again
      // each time: "get machina" / "machina in cart", "add" / "in cart")
      G.style.setProperty('--bh', `${B.h}px`); G.style.setProperty('--kh', `${K.h}px`);
      $('.lb', gLb).textContent = $('.lb', pill).textContent;
      gAr.classList.toggle('on', pill.classList.contains('on'));
      tight();   // THEME: the words and the arrow as they are now (see above)
      gAr.classList.toggle('tight', pill.classList.contains('tight'));
      gAdd.innerHTML = dkKey.innerHTML;
      const ps = cs(pill);
      for (const g of [gLb, gAr]) Object.assign(g.style, { width: `${P.w}px`, height: `${P.h}px`, paddingLeft: ps.paddingLeft, paddingRight: ps.paddingRight, fontSize: ps.fontSize });
      const pa = $('.arr', pill), ga = $('.arr', gAr);
      if (pa && ga) ga.style.width = cs(pa).width;
      gAdd.style.width = `${K.w}px`;
      const ns = cs(nm);
      gNm.textContent = nm.textContent;
      Object.assign(gNm.style, { fontSize: ns.fontSize, fontWeight: ns.fontWeight, letterSpacing: ns.letterSpacing });
      gPc.innerHTML = from.innerHTML;
      Object.assign(gPc.style, { fontSize: `${fs0}px`, letterSpacing: cs(from).letterSpacing });
      gPd.innerHTML = dp.outerHTML;
      Object.assign(gPd.style, { fontSize: `${fs1}px`, letterSpacing: cs(dp).letterSpacing });
      // where the system's dock comes up: R px into the scroll
      const hh = ($('.top') || {}).offsetHeight || 0;
      R = Math.round(Math.min(96, Math.max(56, E.vh * .09)));
      sent.style.top = `${Math.round(R + hh - (row.getBoundingClientRect().top + sy))}px`;
      if (!was) H.p = seg(E.S, 0, R);
      H.key = ''; write(); vis();
    };
    H.frame = (now, dt) => {
      if (!H.on) return false;
      if (H.snap != null && Math.abs(W.scrollY - H.snapY) > .5) H.snap = null;
      const tg = H.snap != null ? H.snap : seg(E.S, 0, R);
      const kp = dt / MIN, p = H.p + Math.max(-kp, Math.min(kp, tg - H.p));
      H.p = Math.abs(p - tg) < 1e-4 ? tg : p;
      write(); vis();
      return H.p !== tg;
    };
    // at rest half-way: to the nearer end, on its own clock (until the
    // page moves again)
    H.settle = () => {
      if (!H.on) return;
      const y = W.scrollY, tg = seg(y, 0, R);
      if (tg > 0 && tg < 1) { H.snap = tg >= .5 ? 1 : 0; H.snapY = y; }
    };
    const mo = new MutationObserver(vis);
    mo.observe(dock, { attributes: true, attributeFilter: ['class'] });
    // (the cart changed: the keys' words may have, after the system's own pass)
    const onCart = () => W.requestAnimationFrame(() => { if (H.on) H.layout(); });
    doc.addEventListener('drayki:cart', onCart);
    // THEME: another version chosen: the pill's words and price may have changed
    doc.addEventListener('drayki:variant', onCart);
    // THEME: registered with the first screen (the editor's unload lets it
    // go), and all of it taken back when the section is taken out
    D.register(H, pdp);
    pdp._off = () => {
      mo.disconnect();
      doc.removeEventListener('drayki:cart', onCart);
      doc.removeEventListener('drayki:variant', onCart);
      if (pdp._atPill) pdp._atPill.disconnect();
      D.unregister(H);
      G.remove();
      pdp.classList.remove('vp-gone');
      root.classList.remove('hand-up', 'pill-foot');
    };
  });

  /* ------------------------------------------- the page's moments (r7) */
  // (drayki: "ça manque de scrolling animations sur la page produit") Read
  // off the system's follower of the scroll, never taking it; poses both
  // ways, arrivals once; nothing at rest; without motion, none of them
  // (every final state, as the page is written).
  // - what's inside: once set down on its card, the kit goes on turning a
  //   little as the page passes it (its back, seen from the other side).
  // - the board's cards come up a step behind the page, one after another
  //   (a row in a wave from the left), the files' card the same; never the
  //   object's card (the object is set down on it). Their figures roll up,
  //   their lines are uncovered, the drawing is drawn: the system's, inside.
  // - the files: the list uncovered from the top by the card's own ground.
  // - what a title heads, faded in just behind it (the board's promises,
  //   the rating, the reviews).
  // THEME: for the page at the start, then for a section the editor draws
  // again (its own parts only); every effect registered with its element,
  // so the editor's unload lets it go.
  D.section('moments', (scope) => {
    const E = D.engine;
    if (!E || !E.on) return;
    const R0 = within(scope);
    const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
    const seg = (v, a, b) => clamp((v - a) / (b - a), 0, 1);
    const ease = (t) => (t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
    const out3 = (t) => 1 - Math.pow(1 - t, 3);

    // the cards (first in the loop: their layout takes their step off
    // before anything inside them is measured, and puts it back after)
    // THEME: one effect per board; the description's card alone (halo, the
    // bundle: .ab-board) comes up as the board's cards do
    for (const board of $$('.in-board, .fl-board, .ab-board', R0)) {
      if (board._rz) continue;
      const rs = $$(board.classList.contains('in-board') ? ':scope > .card:not(.in-obj)' : ':scope > .card', board).map((el) => ({ el, top: 0, lag: 0, on: false, v: '' }));
      if (!rs.length) continue;
      board._rz = true;
      const RZ = {
        always: true, R: 48,
        layout() {
          for (const r of rs) { r.el.style.transform = ''; r.v = ''; }
          this.R = Math.round(clamp(E.vh * .06, 36, 64));
          for (const r of rs) {
            const b = r.el.getBoundingClientRect();
            r.top = b.top + W.scrollY; r.on = b.width > 0;
            r.lag = .14 * clamp((b.left + b.width / 2) / (E.vw || 1), 0, 1);
          }
          queueMicrotask(() => this.frame());
        },
        frame() {
          for (const r of rs) {
            if (!r.on) continue;
            // (its top from the screen's foot to 60 % of it, a little later
            // the further right it stands)
            const k = seg((r.top - E.S) / E.vh, 1.02 - r.lag, .6 - r.lag), y = this.R * (1 - out3(k));
            // (a layer only while it moves; held below the screen, flat)
            const v = y < .25 ? '' : k > 0 ? `translate3d(0,${y.toFixed(1)}px,0)` : `translate(0,${this.R}px)`;
            if (v !== r.v) { r.v = v; r.el.style.transform = v; }
          }
          return false;
        },
      };
      D.register(RZ, board, true);
    }

    // the kit on its card, turning as the page passes (from the moment it
    // is set down: at that scroll it is at its rest, the travel's end)
    const lk = $('#landing', R0) || (R0 !== doc && R0.id === 'landing' ? R0 : null), lo = lk && lk._obj;
    if (lo && !lk._turns) {
      lk._turns = true;
      D.register({
        a: 1, b: 2,
        layout() { const r = lk.getBoundingClientRect(); this.a = Math.max(1, r.top + r.height / 2 + W.scrollY - E.vh / 2); this.b = this.a + E.vh * .6; },
        frame() {
          const v = ease(seg(E.S, this.a, this.b)), d = lo.driver;
          if (!v) { if (d) { lo.driver = null; lo.hot = true; } return false; }
          const R = lo.rest, ry = R.ry + 28 * v;
          if (!d || Math.abs(d.ry - ry) > .01) { lo.driver = { rx: R.rx - 6 * v, ry, rz: R.rz + 2 * v }; lo.hot = true; }
          return false;
        },
      }, lk, true);
    }

    // the files: the list uncovered from the top (see .kx-cw), once; a
    // focus in the card (the search, the tree) finishes it at once. (r7,
    // the QA: it ran from the list's top at 90 % of the screen to 30 %,
    // never faster than .9 s — the card came up an empty dark slab, only
    // "search" on it, for most of its way, and for up to .4 s after a
    // fling.) As the card comes in: from the list's top at the screen's
    // foot to its middle, the rows showing before the card is half up the
    // screen; after a fling, whole in .55 s.
    for (const kc of $$('.fl-board .kx-card', R0)) {   // THEME: every files' card of the scope
      const kb = $('.kx-body', kc);
      if (!kb || kb._kq) continue;
      kb._kq = true;
      const cw = doc.createElement('span');
      cw.className = 'kx-cw'; cw.setAttribute('aria-hidden', 'true'); cw.innerHTML = '<i></i>';
      kb.appendChild(cw);
      const strip = cw.firstChild;
      const write = (p) => { if (p >= 1) cw.remove(); else cw.style.setProperty('--kq', ease(p).toFixed(4)); };
      const U = new D.Once(kb, write, .55, .98, .5);
      const lay0 = U.layout.bind(U);
      U.layout = () => { lay0(); cw.style.setProperty('--ke', `${Math.round(clamp(kb.offsetHeight * .3, 72, 160))}px`); };
      U.onSeen = (on) => { strip.style.willChange = on && !U.done ? 'transform' : ''; };
      kc.addEventListener('focusin', () => { if (!U.done) { U.fin = true; U.hot = true; D.wake(); } });
      write(0);
      D.register(U, kb);
    }

    // (r7, the QA: "right after payment." showed alone before "instant
    // download.", the 0 %'s lines before the 0, a review's stars and words
    // before its title) What a title heads comes just behind it: faded in
    // as the title's curtain passes, read off that curtain's own progress
    // (the scroll's, or its clock's at rest: a tenth of a second behind
    // it there). Never there before the title, never waiting after it
    // (the page's CSS holds them until this takes over). Opacity only,
    // written on change; gone once the title is whole.
    const behind = (lead, els) => {
      const c = lead && lead._cur;
      els = els.filter(Boolean);
      if (!c || !els.length || lead._bh) return;   // THEME: once per title
      lead._bh = true;
      // (written inline, 1 at the end of the ramp, until the title's
      // curtain is done: let go only then — the CSS holds them while it
      // is not, and let go a frame early they blinked out)
      let v = null, now = false;
      const put = () => {
        const s = c.p >= 1 ? '' : now ? '1' : seg(c.p, .3, .9).toFixed(3);
        if (s !== v) { v = s; for (const e of els) e.style.opacity = s; }
        return s === '';
      };
      if (put()) return;
      // (a focus in one — the keys on "write a review" — shows them at
      // once and finishes the title on its clock, as a focus in the title
      // does: never a key on a line not there yet)
      for (const e of els) e.addEventListener('focusin', () => { if (c.p < 1) { now = true; put(); c.fin = true; c.hot = true; D.wake(); } });
      D.register({ always: true, frame() { if (put()) D.unregister(this); return false; } }, lead);   // THEME: with its title
    };
    for (const b of $$('#inside .dl', R0)) behind($('.hd', b), [$('.sub', b)]);
    for (const b of $$('#inside .rf', R0)) behind($(':scope > .big', b), $$(':scope > div > *', b));
    // THEME (r8): the description's words and its key, behind its title
    for (const b of $$('.ab-card', R0)) behind($(':scope > .hd', b), [$(':scope > .ab-b', b)]);
    for (const s of $$('#reviews .rv-sum', R0)) behind($(':scope > .big', s), $$(':scope > div > *', s));
    for (const r of $$('#reviews .rv-card', R0)) behind($(':scope > .rv-t', r), $$(':scope > :not(.rv-t)', r));
    // (and "bought it? say what you made with it." after the last review,
    // never under a review still to come)
    // THEME: in the theme the reviews are Judge.me's (no .rv-card, no curtain
    // on their titles): these two find nothing, the line shows as it is
    const rl = $$('#reviews .rv-card', R0).pop();
    if (rl) behind($(':scope > .rv-t', rl), $$('#reviews .rv-w > *', R0));
    // (a phone: the reviews are a rail. A swipe along it moves no page, so
    // the page's rest never came after it: a review swiped in with its
    // title half uncovered stayed so, its words half there, until the
    // page moved. At rest on the rail, the same as at rest on the page:
    // a title half-way is finished on its own clock.)
    const rv = $('#reviews .rv-list', R0);
    if (rv && !rv._rt) {
      rv._rt = true;
      let rt = 0;
      rv.addEventListener('scroll', () => {
        clearTimeout(rt);
        rt = setTimeout(() => {
          for (const t of $$('.rv-t', rv)) { const c = t._cur; if (c && c.p > 0 && c.p < 1) { c.fin = true; c.hot = true; } }
          D.wake();
        }, 360);
      }, { passive: true, capture: true });   // THEME: capture: the rail is Judge.me's list inside it
    }
  });

  /* ------------------------------------------- THEME: the bundle's kits */
  // bundle-contents: each version's kits are in the page (the others hidden);
  // a version chosen shows its own and draws the pile again with its kits
  // (script[data-bundle-map]: { version id: [handles] }).
  D.section('bundle', (scope) => {
    for (const sec of $$('[data-bc]', within(scope))) {
      if (sec._bc) continue;
      sec._bc = true;
      const map = json($('script[data-bundle-map]', sec)) || {};
      const h = sec.dataset.bc, wrap = $('.bc-st', sec);
      const pose = (($('.stack', wrap) || {}).dataset || {}).pose || '50 -36';
      let at = ($('[data-bc-v]:not([hidden])', sec) || {}).dataset?.bcV || '';
      const show = (id) => {
        id = String(id);
        if (id === at) return;
        at = id;
        for (const v of $$('[data-bc-v]', sec)) v.hidden = v.dataset.bcV !== id;
        const hs = Array.isArray(map[id]) ? map[id] : [];
        if (wrap) {
          wrap.hidden = !hs.length;
          const names = $$(`[data-bc-v="${id}"] .bc-k .nm`, sec).map((n) => n.textContent.trim());
          const tpl = wrap.dataset.stacked || '';
          if (hs.length) restack(wrap, hs, pose, null, tpl ? tpl.replace('{count}', hs.length).replace('{names}', names.join(', ')) : '');
        }
      };
      const onVar = (e) => { const d = e.detail; if (d && d.h === h && d.variant) show(d.variant.id); };
      doc.addEventListener('drayki:variant', onVar);
      sec._off = () => doc.removeEventListener('drayki:variant', onVar);
      // (a version chosen before this section started)
      const v = VARS.get(h);
      if (v) show(v.id);
    }
  });

  /* -------------------------------------- THEME: the description (about) */
  // (r8) snippet about-card: a long text (data-ab) is cut at a whole line by
  // the page's CSS from the first image. « read more » unfolds it — the
  // height eased from the cut to the whole, as the questions' — and says
  // « read less »; that folds it back, and if the key has gone above the
  // screen by then, the card's top is brought back into view. A focus that
  // lands in the cut part (a link of the text) unfolds it. A text that fits
  // whole at this width loses its cut and its key (.ab-fit): measured as the
  // section starts, again once the font is in and when the width changes —
  // the card is far below the first screen then, nothing moves in view.
  // Without motion: no easing.
  const still = W.matchMedia('(prefers-reduced-motion: reduce)');
  const abFit = (c) => {
    if (c.classList.contains('ab-open') || c._an) return;
    const say = $('.ab-say', c);
    if (!say || !say.getClientRects().length) return;   // (not drawn: nothing to measure)
    c.classList.remove('ab-fit');
    c.classList.toggle('ab-fit', say.scrollHeight <= say.clientHeight + 2);
  };
  function about(scope) {
    for (const c of $$('.ab-card[data-ab]', within(scope))) {
      if (c._ab) continue;
      const say = $('.ab-say', c), key = $('.ab-more', c);
      if (!say || !key) continue;
      c._ab = true;
      const more = key.getAttribute('data-more') || key.textContent, less = key.getAttribute('data-less') || more;
      const done = (on) => {
        c._an = null;
        if (!on) c.classList.remove('ab-open');
        if (on) return;
        const top = ($('.top') || {}).offsetHeight || 0;
        if (key.getBoundingClientRect().top < top) c.scrollIntoView({ block: 'start', behavior: still.matches ? 'auto' : 'smooth' });
      };
      const set = (on) => {
        // (from where it is: an easing stopped half-way goes on from there)
        const h0 = say.getBoundingClientRect().height;
        if (c._an) { c._an.cancel(); c._an = null; }
        // (the height to reach: the whole text, or the cut — read with the
        // class off, in the same frame)
        c.classList.remove('ab-open');
        const cut = say.offsetHeight;
        c.classList.add('ab-open');
        const h1 = on ? say.offsetHeight : cut;
        key.setAttribute('aria-expanded', on ? 'true' : 'false');
        key.textContent = on ? less : more;
        if (still.matches || !say.animate || Math.abs(h1 - h0) < 2) { done(on); return; }
        c._an = say.animate([{ height: `${h0}px` }, { height: `${h1}px` }], { duration: Math.min(D.phone && D.phone() ? 300 : 520, 300 + Math.abs(h1 - h0) * .8), easing: 'cubic-bezier(.65,0,.35,1)' });
        c._an.onfinish = () => done(on);
      };
      key.addEventListener('click', () => set(key.getAttribute('aria-expanded') !== 'true'));
      say.addEventListener('focusin', () => { if (key.getAttribute('aria-expanded') !== 'true' && !c.classList.contains('ab-fit')) set(true); });
      abFit(c);
    }
  }
  about(doc);
  D.section('about', about);
  {
    let aw = W.innerWidth, aq = 0;
    const again = () => { for (const c of $$('.ab-card[data-ab]')) abFit(c); };
    W.addEventListener('resize', () => {
      if (W.innerWidth === aw || aq) return;
      aq = W.requestAnimationFrame(() => { aq = 0; aw = W.innerWidth; again(); });
    }, { passive: true });
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(again);
  }

  /* --------------------------------------- the skip link (THEME: delegated) */
  // « skip to get … » goes to the buy action on the screen (see above)
  doc.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a.skip[href="#MainActionBlock"]');
    if (!a) return;
    const k = keys(), to = live(k); if (!to) return;
    e.preventDefault();
    const r = to.getBoundingClientRect();
    to.focus({ preventScroll: r.top >= 0 && r.bottom <= W.innerHeight });
  });

  /* ------------------------------------------------------- the files */
  // The list keeps to its own height (the page's CSS), so it scrolls
  // inside. Focus alone does not bring a folder's own row into view (a
  // folder open is a tall item, already "in view" by its contents): the
  // row the keys land on is brought in, the least scroll that shows it.
  // A new search starts at the top of the list. (Local to this page: the
  // explorer itself is the system's.) THEME: delegated (the editor draws
  // the section again)
  doc.addEventListener('focusin', (e) => {
    const tree = e.target.closest && e.target.closest('.fl-board .kx-browser');
    if (!tree) return;
    const row = e.target.closest('[role="treeitem"]')?.querySelector(':scope > .kx-r');
    if (!row) return;
    W.requestAnimationFrame(() => {
      const t = tree.getBoundingClientRect(), r = row.getBoundingClientRect();
      if (r.top < t.top) tree.scrollTop -= t.top - r.top;
      else if (r.bottom > t.bottom) tree.scrollTop += r.bottom - t.bottom;
    });
  });
  doc.addEventListener('input', (e) => {
    const s = e.target;
    if (!s || !s.classList || !s.classList.contains('kx-search')) return;
    const w = s.closest('.fl-board .kx-wrap'), tree = w && $('.kx-browser', w);
    if (tree) tree.scrollTop = 0;
  });

  /* ------------------------------------- THEME: « write a review » (Judge.me) */
  // Judge.me's own link is hidden (product.css, « judge.me »): ours opens its
  // form, brings it into view and puts the focus in its first field. No
  // widget on the page: the link goes to it (#judgeme_product_reviews).
  doc.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('[data-rv-write]');
    if (!a) return;
    const rv = a.closest('.rv') || doc, link = $('.jdgm-write-rev-link', rv);
    if (!link) return;
    e.preventDefault();
    link.click();
    W.setTimeout(() => {
      const f = $('.jdgm-form-wrapper', rv);
      if (!f || !f.getClientRects().length) return;
      const still = W.matchMedia('(prefers-reduced-motion: reduce)').matches;
      f.scrollIntoView({ block: 'start', behavior: still ? 'auto' : 'smooth' });
      const first = $('input:not([type="hidden"]), textarea', f);
      if (first) first.focus({ preventScroll: true });
    }, 60);
  });

  /* --------------------------------- THEME: Judge.me's dates (the reviews) */
  // Judge.me writes each review's date in the store's format (« 07/12/2026 »);
  // the page says it as the mockup does, in lowercase: « 12 jul 2026 » — read
  // from the date it keeps (data-content « 2026-07-12 12:27:53 UTC », or
  // datetime), never from the words shown, and the day as Judge.me dated it
  // (no time zone applied). Its list is drawn late, and again for each page
  // of reviews: an observer on .rv writes the new ones. Idempotent: a date
  // already written is left alone, so its own write never calls it again;
  // one observer per .rv (the editor draws the section again: a new .rv).
  const MON = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
  const dayOf = (t) => {
    const m = String(t.getAttribute('data-content') || t.getAttribute('datetime') || '').match(/(\d{4})-(\d{2})-(\d{2})/);
    if (!m || +m[2] < 1 || +m[2] > 12) return '';
    return `${+m[3]} ${MON[+m[2] - 1]} ${m[1]}`;
  };
  const dates = (rv) => {
    for (const t of $$('.jdgm-rev__timestamp', rv)) {
      const s = dayOf(t);
      if (s && t.textContent !== s) t.textContent = s;
    }
  };
  function reviews(scope) {
    const R0 = within(scope);
    for (const rv of [...(R0 !== doc && R0.matches && R0.matches('.rv') ? [R0] : []), ...$$('.rv', R0)]) {
      if (rv._jd) continue;
      rv._jd = new MutationObserver(() => dates(rv));
      rv._jd.observe(rv, { childList: true, subtree: true, characterData: true });
      rv._off = () => rv._jd.disconnect();
      dates(rv);
    }
  }
  reviews(doc);
  D.section('reviews', reviews);

  /* ------------------------------- THEME: a section taken out in the editor */
  // what a section's init set up outside it (the twin in <body>, listeners on
  // the document, observers) is taken back; the system lets its effects go
  doc.addEventListener('shopify:section:unload', (e) => {
    const t = e.target;
    if (!t || !t.querySelectorAll) return;
    for (const el of [t, ...$$('.pdp, .mix[data-mix], [data-bc], .rv', t)]) {
      if (typeof el._off === 'function') { try { el._off(); } catch (err) { /* fine */ } el._off = null; }
    }
  });
})();
